import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { useEffect, useMemo } from 'react';
import { bindActionCreators } from 'redux';
import { addCrossSell, addPromoCode, addSubscription, addToCart, checkRedemptionCodeValidity, emptyCart, forgetCart, loadCart, modifyCart, modifyGiftCards, modifyLineItem, purchasePrepaidSubscription, redeemGiftCard, redeemPrepaidSubscription, removeFromCart, removePromoCode, applyGiftCard, removeGiftCard, removeGiftCardItem } from '../redux/actions';
/**
 * The `useCart` hook returns information about the current shopping cart, and
 * functions for creating and updating the shopping cart.
 *
 * @example
 *
 * ```javascript
 * import { useCart } from '@chordcommerce/react-autonomy'
 *
 * // inside a function component
 * const { cart, addToCart } = useCart()
 * ```
 *
 * @category Hook
 */
export function useCart() {
  var cart = useSelector(function (state) {
    return state.cart;
  }, shallowEqual);
  var isFetching = cart.isFetching,
    isLoaded = cart.isLoaded,
    error = cart.error;
  var dispatch = useDispatch();
  var actionDispatches = useMemo(function () {
    return bindActionCreators({
      addCrossSell: addCrossSell,
      addPromoCode: addPromoCode,
      addSubscription: addSubscription,
      addToCart: addToCart,
      applyGiftCard: applyGiftCard,
      removeGiftCard: removeGiftCard,
      removeGiftCardItem: removeGiftCardItem,
      checkRedemptionCodeValidity: checkRedemptionCodeValidity,
      emptyCart: emptyCart,
      forgetCart: forgetCart,
      loadCart: loadCart,
      modifyCart: modifyCart,
      modifyGiftCards: modifyGiftCards,
      modifyLineItem: modifyLineItem,
      purchasePrepaidSubscription: purchasePrepaidSubscription,
      redeemGiftCard: redeemGiftCard,
      redeemPrepaidSubscription: redeemPrepaidSubscription,
      removeFromCart: removeFromCart,
      removePromoCode: removePromoCode
    }, dispatch);
  }, [dispatch]);
  useEffect(function () {
    if (isFetching || isLoaded || error) return;
    if (Object.keys(cart.data).length === 0) {
      actionDispatches.loadCart();
    }
  }, [cart]);
  return _objectSpread({
    cart: cart.data,
    promoCode: cart.promoCode,
    isFetching: isFetching,
    isLoaded: isLoaded,
    error: error
  }, actionDispatches);
}